import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class AttachmentService {
  baseUrl = 'document-attachment';

  getList = (documentId) => BaseService.get({ url: `${this.baseUrl}/get-list/${documentId}` });
  remove = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  display = async (id) => Utils.file.attachment.get(`${this.baseUrl}/display/${id}`);
  merge = async (ids) => Utils.file.attachment.get(`${this.baseUrl}/merge-attachments-view/${ids}`);
  download = (id) => Utils.file.attachment.download(`${this.baseUrl}/download/${id}`);
  downloadAll = (documentId) => Utils.file.attachment.download(`${this.baseUrl}/download-all/${documentId}`);
  save = (attachment) => BaseService.post({ url: `${this.baseUrl}/save-attachment`, data: attachment });
  canDisplay = (id) => BaseService.get({ url: `${this.baseUrl}/can-display/${id}` });
}

export default new AttachmentService();
